<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Holiday"
      id="admin_view_holiday_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="'/admin/hollidays/list/view/' + $route.params.id + '/edit'"
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Edit Holiday
      </v-btn>
      <v-btn
        :to="'/admin/hollidays/list/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon> Remove Holiday
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="holliday.name"
        :icon="'mdi-party-popper'"
        :img_src="holliday.thumb_nail"
        :facts="view_header_facts"
        :description="holliday.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Businesses Holiday Schedules"
      id="admin_view_hollidays_businesses_schedule"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="business_holliday_schedules"
        :headers="business_holliday_schedules_headers"
        :show_description="true"
      >
        <template v-slot:[`item.owner`]="{ item }">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This holiday has {{ business_holliday_schedules.length }} businesses schedules
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="view_business(item)"  x-small rounded text color="success">
            <v-icon>mdi-eye</v-icon> 
          </v-btn>
        </template> 
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminHollidaysView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      holliday: {
        id: 0,
        name: "",
        description: "",
        starts_on: new Date().toISOString().substr(0, 10),
        ends_on: new Date().toISOString().substr(0, 10),
        thumb_nail: Utils.default_holidays_thumbnail,
      },
      business_holliday_schedules: [],
      business_holliday_schedules_headers: [
        { text: "Business", value: "business.name" },
        { text: "Opens", value: "opens", sortable: false  },
        { text: "Closes", value: "closes", sortable: false  },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        { text: "Starts On:", val: this.holliday.starts_on },
        { text: "End On:", val: this.holliday.ends_on },
      ];
      return facts;
    },
  },
  mounted() {
    var holiday_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Holiday Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Holidays",
          disabled: false,
          href: "/admin/hollidays",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/hollidays/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/hollidays/list/view/" + holiday_id ,
        },
      ],
    });
    this.$emit("on-show-loader");
    ServerClient.Holidays.get_holiday(
      {
        id: holiday_id,
        is_admin: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.holliday = res.holliday;
        this.business_holliday_schedules = res.business_holliday_schedules;
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log("Errors while loading holliday details on admin", errors);
      }
    );
  },
  methods: {
    view_business(business) {
      this.$router.push("/admin/businesses/view/" + business.id);
    },
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>